// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x0xr","col":"styles_col__3EUmg"};